import axios from "axios";
import constants from "../constants";
import { setUserDetails, setUserLogin } from "../User/reducer";

const setRegisterConfirm = (isRegistered, token) => {
  return {
    type: constants.reducerActions.registered,
    isRegistered,
    token,
  };
};

export const signUpConsultant = (consultantDetails) => async (dispatch) => {
  try {
    const url = `/consultant/register`;
    const { responseStatus, responseBody } = await axios.post(
      url,
      consultantDetails
    );
    if (responseStatus === constants.status.created) {
      const { data } = responseBody;
      dispatch(setRegisterConfirm(true, data.access_token));
      dispatch(setUserLogin(data.access_token, constants.roles.consultant));
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("role", constants.roles.consultant);
    }
    return { responseStatus };
  } catch (error) {
    console.log(error);
    return { responseStatus: error.response.status };
  }
};

const setAllJobs = (jobs, totalJobsCount, isFetching) => {
  return {
    type: constants.reducerActions.allJobs,
    totalJobsCount,
    jobs,
    isFetching,
  };
};

const setFetching = (isFetching) => {
  return {
    type: constants.reducerActions.fetchingJobs,
    isFetching,
  };
};

export const getAllJobs = (page) => async (dispatch) => {
  try {
    const url = `/consultant/jobs?page=${page}&size=10`;
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setAllJobs(data.items, data.total, false));
    }
    return { responseStatus };
  } catch (error) {
    console.log(error);
    return { responseStatus: error.response.status };
  }
};

const setJobDetail = (jobDetail) => {
  return {
    type: constants.reducerActions.jobDetail,
    jobDetail,
  };
};

export const getJobDetail = (jobId) => async (dispatch) => {
  try {
    dispatch(setFetching(true));
    const url = `/consultant/jobs/${jobId}`;
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setJobDetail(data));
      dispatch(setFetching(false));
    }
  } catch (error) {
    console.log(error);
  }
};

const setUserSkills = (userSkills, isFetching) => {
  return {
    type: constants.consultantActions.userSkills,
    userSkills,
    isFetching,
  };
};

export const fetchUserSkills = () => async (dispatch) => {
  try {
    const url = `/consultant/skills`;
    const { responseStatus, responseBody } = await axios.get(url);
    console.log(responseStatus, responseBody);

    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setUserSkills(data, false));
    }
    return responseStatus;
  } catch (error) {
    console.log(error);
  }
};

const setAllSkills = (allSkills) => {
  return {
    type: constants.reducerActions.skills,
    allSkills,
  };
};

export const fetchAllSkills = () => async (dispatch) => {
  try {
    const url = `/consultant/skills/all`;
    const { responseStatus, responseBody } = await axios.get(url);
    console.log(responseStatus, responseBody);

    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setAllSkills(data));
    }
    return responseStatus;
  } catch (error) {
    console.log(error);
  }
};

export const addSkills = (skillId) => async (dispatch) => {
  try {
    const url = `/consultant/skills`;
    const { responseStatus } = await axios.put(url, { skillId });
    console.log(responseStatus);

    if (responseStatus === constants.status.success) {
      await dispatch(fetchUserSkills());
      await dispatch(fetchAllSkills());
    }
    return responseStatus;
  } catch (error) {
    console.log(error);
  }
};

const isJobApplied = (applied) => {
  return {
    type: constants.consultantActions.jobApplied,
    applied,
  };
};

export const checkApplyJob = (jobId) => async (dispatch) => {
  try {
    const url = `/consultant/job/apply/check?jobId=${jobId}`;
    const { responseStatus, responseBody } = await axios.get(url);
    console.log(responseStatus, responseBody);

    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(isJobApplied(data));
    }
  } catch (error) {
    console.log(error);
  }
};

export const applyJob = (jobId, comment) => async (dispatch) => {
  try {
    const url = `/consultant/job/apply`;
    const { responseStatus } = await axios.post(url, {
      jobId,
      comment,
    });
    return responseStatus;
  } catch (error) {
    console.log(error);
  }
};

export const getNextSkills = (length) => {
  return {
    type: constants.consultantActions.sliceSkills,
    length,
  };
};

export const removeSkills = (skills, userSkills) => async (dispatch) => {
  try {
    dispatch(setUserSkills(userSkills, false));
    const url = "/consultant/skills";
    const { responseStatus, responseBody } = await axios.delete(url, {
      data: {
        skillId: skills,
      },
    });
    console.log(responseStatus, responseBody);
    if (responseStatus === constants.status.success) {
      await dispatch(fetchAllSkills());
    }
    return responseStatus;
  } catch (error) {
    console.log(error);
  }
};

const searchJobsCount = (jobCount) => {
  return {
    type: constants.consultantActions.searchJobs,
    jobCount,
  };
};

export const searchJobs = (searchText, page) => async (dispatch) => {
  try {
    const url = `/consultant/job/search?Search=${searchText}&page=${page}&size=10`;
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(searchJobsCount(data.total));
      const searchedJobs = data.items;
      return { searchedJobs, responseStatus };
    }
  } catch (error) {
    console.log(error.response);
    return { responseStatus: error.response.status };
  }
};

const setAllApplications = (applications) => {
  return {
    type: constants.consultantActions.applications,
    applications,
  };
};

export const getAllApplications = () => async (dispatch) => {
  try {
    const url = `/consultant/applications`;
    const { responseStatus, responseBody } = await axios.get(url);
    console.log(responseBody, responseStatus);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setAllApplications(data.items));
    }
    return { responseStatus };
  } catch (error) {
    console.log(error);
    return { responseStatus: error.response.status };
  }
};

const setApplicationDetail = (applicationDetail) => {
  return {
    type: constants.consultantActions.application,
    applicationDetail,
  };
};

export const getApplicationById = (applicationId) => async (dispatch) => {
  try {
    const url = `/consultant/applications/${applicationId}`;
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setApplicationDetail(data));
    }
    return { responseStatus };
  } catch (error) {
    console.log(error);
  }
};

const setAllOffers = (offersList) => {
  return {
    type: constants.consultantActions.allOffers,
    offersList,
  };
};

export const getAllOffers = () => async (dispatch) => {
  try {
    const url = "/consultant/applications/offers";
    const { responseBody, responseStatus } = await axios.get(url);
    console.log(responseBody, responseStatus);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setAllOffers(data));
    }
    return { responseStatus };
  } catch (error) {
    console.log(error);
  }
};

export const giveOffer = (offerId, data) => async (dispatch) => {
  try {
    const url = `/consultant/applications/offers/${offerId}`;
    const { responseStatus, responseBody } = await axios.post(url, data);
    console.log(responseBody, responseStatus);
    await dispatch(getAllOffers());
    return { responseStatus };
  } catch (error) {
    console.log(error);
    return { responseStatus: error.response.status };
  }
};

const setCurrentJobs = (currentJobs) => {
  return {
    type: constants.consultantActions.currentJobs,
    currentJobs,
  };
};

export const getCurrentJobs = () => async (dispatch) => {
  try {
    const url = "/consultant/my/jobs";
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setCurrentJobs(data.items));
    }
    return {
      responseStatus,
    };
  } catch (error) {
    console.log(error);
    return {
      responseStatus: error.response.status,
    };
  }
};

const dashboardDetails = (details) => {
  return {
    type: constants.consultantActions.dashboard,
    details,
  };
};

export const getDashboardDetails = () => async (dispatch) => {
  try {
    const url = "/consultant/dashboard";
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      dispatch(dashboardDetails(responseBody));
    }
  } catch (error) {
    console.log(error);
  }
};

export const getConsultantPersonalInfo = () => async (dispatch) => {
  try {
    const url = "/consultant/personal-info";
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      dispatch(setUserDetails(responseBody.data));
    }
  } catch (error) {
    console.log(error);
  }
};

export const updatePersonalInfo =
  (firstName, lastName, mobileNumber, country, address, profileImageId) =>
  async (dispatch) => {
    try {
      const data = {
        firstName,
        lastName,
        mobileNumber,
        country,
        address,
        profileImageId,
      };
      const url = "/consultant/personal-info";
      const { responseStatus } = await axios.put(url, data);
      if (responseStatus === constants.status.success) {
        await dispatch(getConsultantPersonalInfo());
      }
    } catch (error) {
      console.log(error);
    }
  };

const setProfileCompletion = (profileCompletion) => {
  return {
    type: constants.consultantActions.profileCompletion,
    profileCompletion,
  };
};

export const getProfileCompletion = () => async (dispatch) => {
  try {
    const url = "/consultant/profileCompletion";
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setProfileCompletion(data.profileCompletion));
    }
  } catch (error) {
    console.log(error);
  }
};
